exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "index{display:block}index header h1{font-family:Stag Sans;font-weight:400;font-size:36px;color:#0072c9;text-align:center}index .cards-container{-moz-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-ms-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-pack:justify;-moz-justify-content:space-between;justify-content:space-between;-ms-flex-align:center;-ms-flex-line-pack:center;align-content:center;width:480px;min-height:450px;margin:auto}index .cards-container,index a.card{display:-moz-flex;display:-ms-flexbox;display:flex;-moz-align-items:center;align-items:center}index a.card{-ms-flex-pack:center;-moz-justify-content:center;justify-content:center;-ms-flex-align:center;width:210px;height:100px;background-color:#fff;border-radius:10px;border:1px solid #dddfe2;margin:10px;font-size:15px;cursor:pointer}index a.card:hover{text-decoration:none;background-color:#0072c9;color:#fff}index a.card:focus{text-decoration:none;background-color:#04408f;color:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./client/app/features/mainRouting/index/index.scss
// module id = 1039
// module chunks = 0